export default function validateSocialSecurityNumberKey() {
  return (_, newValue: string | null) => {
    const errorMessage = "Le numéro de sécurité sociale est invalide";
    // The allowBlank is not handed for the moment
    if (!newValue) {
      return true;
    }
    // Remove a potential trailing letter
    let number = newValue.substring(0, 15);
    // Handle specific cases for corsica
    // See https://fr.wikipedia.org/wiki/Numéro_de_sécurité_sociale_en_France#lien_F
    number = number.replace("2A", "19");
    number = number.replace("2B", "18");

    if (number.length !== 15 || isNaN(Number(number))) {
      return errorMessage;
    }

    const body = Number(number.substring(0, 13));
    const key = Number(newValue.substring(13, 15));

    if (97 - (body % 97) === key) {
      return true;
    }
    return errorMessage;
  };
}
